<template>
  <div class="flex message d-flex message-bot messsge-loading" aria-hidden="true" :style="{'font-size': '14vw'}">
    <!-- contains message and response card -->
    <v-layout column ma-2 class="message-layout">

      <!-- contains message bubble and date -->
      <v-flex  v-scroll d-flex class="message-bubble-date-container">
        <v-layout column class="message-bubble-column">

          <!-- contains message bubble and avatar -->
              <!-- <div v-bind="checkpicture(this.$store.state.messages, 'type')"> -->
       
    <!-- </div> -->
          <v-flex
          v-scroll
           d-flex class="message-bubble-avatar-container">
           <!-- <div style="width: 44px; height: 44px; float:left; border-radius: 50%; border: 3px solid #eee; overflow: hidden;"

    > -->
    <!-- <div v-if="message">
      
        <img src="@/assets/title@2x.png" width="40" height="40"  />
    </div> -->

            <v-layout row class="message-bubble-row" >
                 <div
                  v-scroll
                class="message-bubble"
                aria-hidden="true"
                style="
    display: block;
"
              >
                <span>{{ progress }}</span>
              </div> 
     
            
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/

export default {
  name: 'message-loading',
  props: ["message"],

  data() {
    return {
      progress: '.',
      // msg: this.message,
    };
  },
  mounted(){
    // console.log('loading====', message)
  },
  computed: {
  },
  methods: {
  },
  watch: {
    msg(newVal) {
      this.msg = newVal;
      // console.log("lmsg--");
    },
  },
  directives: {
scroll: {
      inserted(el) {
        console.log("el---", el);
        el.scrollIntoView();
      },
    },
  },
  created() {
    this.interval = setInterval(() => {
      if (this.progress.length > 2) {
        this.progress = '.';
      } else {
        this.progress += '.';
      }
    }, 500);
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.message, .message-bubble-column {
  flex: 0 0 auto;
}

.message, .message-bubble-row {
  max-width: 80vw;
}

.message-bubble {
  border-radius: 24px;
  border-top-left-radius: 0px;
  display: flex;
  height: 13vw;
  font-size: calc(1em + 0.25vmin);
  padding: 0 12px;
  width: fit-content;
  align-self: center;
}


.message-bot .message-bubble {
  background-color: #FFFFFF; /* red-50 from material palette */
}


</style>
 <style>
 
    span {
        background: linear-gradient(to right, #999999, #C1C1C1, #F3F3F3);
        -webkit-background-clip: text;
        color: transparent;
        position: relative;
        top: -7vw;
        display: block;
    }
    </style>